export const blockIconsCommunicationMailOutline = (
	<span className='material-symbols-outlined'>mail_outline</span>
);
